import React from "react";
import Button from '../button';
import "./styles.css";

const OfferCard = ({ descText, backgroundImg, textStyle, buttonStyle, setCategory }) => {
  return (
    <div
      className="card-container"
      style={{
        backgroundImage: `Url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundRepeat: "no-repeat",
        objectFit: "cover",
        backgroundPosition:'center center'
      }}
      onClick ={()=>setCategory()}
    >
      <div className="desc-container-main">
        <p style={{ textStyle }}>{descText}</p>
      </div>
      <div className="desc-button">
                <Button style={{buttonStyle}} label={'Book Now'}/>
            </div>
    </div>
  );
};

export default OfferCard;
